import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { AlertaPerfilRiesgo } from '../_models/alerta-perfil-riesgo';

@Injectable({
  providedIn: 'root'
})
export class AlertaPerfilRiesgoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/alertasPerfilesRiesgos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as AlertaPerfilRiesgo[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( `${this.rutServicio}/enabled` ).pipe( map( res => res as AlertaPerfilRiesgo[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( `${this.rutServicio}/${id}` ).pipe( map( res => res as AlertaPerfilRiesgo ) );
  }

  obtenerPorIdAlerta( id: string ) {
    return this.httClient.get( `${this.rutServicio}/alerta/${id}` ).pipe( map( res => res as AlertaPerfilRiesgo[] ) );
  }

  crear( regCrear: AlertaPerfilRiesgo ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as AlertaPerfilRiesgo ) );
  }

  actualizar( regActualizar: AlertaPerfilRiesgo ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( registros: AlertaPerfilRiesgo[] ) {
    registros.forEach( r => r.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado() );
    return this.httClient.post( `${this.rutServicio}/bulk`, registros ).pipe( map( res => res as any ) );
  }
}
